import { useContactActivity } from "@shared/generated/radar/queries/contactsController/useContactActivity";
import { contactActivityQueryResponseSchema } from "@shared/generated/radar/zod/contactsController/contactActivitySchema";

export const MAX_SIGNALS = 6;
const EVENTS_PER_CONTACT = 1;

// Shared by SocialSignalsSection (the cards) and RadarSignalsPanel (the "X
// new" chip in the header) so both read the same query instead of each
// firing their own fetch.
export const useSocialSignals = () =>
  useContactActivity(
    {
      limit: MAX_SIGNALS,
      eventsPerContact: EVENTS_PER_CONTACT,
      sortBy: "recent",
    },
    undefined,
    {
      query: {
        select: (data) => contactActivityQueryResponseSchema.parse(data),
      },
    },
  );
